// extracted by mini-css-extract-plugin
module.exports = {"pageTitle":"UXCatPageTitle_pageTitle__1umhn","bigFont":"UXCatPageTitle_bigFont__CqoVe"};